import React from 'react';
import { Types } from '@fiverr-private/theme';
import { Container } from '@fiverr-private/layout_components';
import { footer } from './style.ve.css';

interface IdentificationFormFooterProps {
    children: React.ReactNode;
    justifyContent?: Types.ContainerProps['justifyContent'];
}

export const IdentificationFormFooter = ({
    children,
    justifyContent = 'spaceBetween',
}: IdentificationFormFooterProps) => (
    <Container
        display="flex"
        justifyContent={justifyContent}
        paddingTop={{ default: '4', sm: '8' }}
        marginTop="auto"
        className={footer}
    >
        {children}
    </Container>
);
